import React, { useEffect, useLayoutEffect } from "react";
import { Cookies } from "react-cookie";
import { connect } from "react-redux";
import { Navigate, Route, Routes, useNavigate, useSearchParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import { COOKIE_JWT, COOKIE_SAP } from "../../common/constant";
import nav from "../../common/navigate";
import { doLogin } from "../../ducks/login";
import {
  loadMaintenanceStatus,
  MAINTENANCE_CHECKED,
  MAINTENANCE_ENABLED,
  MAINTENANCE_MESSAGE_DE,
  MAINTENANCE_MESSAGE_EN
} from "../../ducks/maintenance";
import MessagesContainer from "../common/MessagesContainer";
import LoginContainer from "../login/LoginContainer";
import MaintenancePage from "../maintenance/MaintenancePage";
import ForgotPasswordContainer from "../user/forgotPassword/ForgotPasswordContainer";
import PasswordTokenResetContainer from "../user/forgotPassword/PasswordTokenResetContainer";
import UserContainer from "../user/UserAreaContainer";

const AppContent = ({ doLogin, loadMaintenanceStatus, maintenanceChecked, maintenanceEnabled, messageDe, messageEn }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const queryToken = searchParams.get("jwt");
  const sapToken = searchParams.get("sap_token");
  const cookies = new Cookies();

  const jwtFromCookie = cookies.get(COOKIE_JWT);
  const sapFromCookie = cookies.get(COOKIE_SAP);

  useLayoutEffect(() => {
    nav.init(navigate);
  }, [navigate]);

  useEffect(() => {
    loadMaintenanceStatus();
  }, [loadMaintenanceStatus]);

  useLayoutEffect(() => {
    if (!maintenanceChecked || maintenanceEnabled) {
      return;
    }

    if (sapToken && queryToken) {
      doLogin(queryToken, sapToken);
    } else if (queryToken) {
      doLogin(queryToken);
    } else if (sapFromCookie && jwtFromCookie) {
      doLogin(jwtFromCookie, sapFromCookie);
    } else if (jwtFromCookie) {
      doLogin(jwtFromCookie);
    }
  }, [doLogin, jwtFromCookie, maintenanceChecked, maintenanceEnabled, queryToken, sapFromCookie, sapToken]);

  if (!maintenanceChecked) {
    return (
      <main>
        <MessagesContainer />
      </main>
    );
  }

  if (maintenanceEnabled) {
    return (
      <main>
        <MaintenancePage messageDe={messageDe} messageEn={messageEn} />
        <MessagesContainer />
      </main>
    );
  }

  return (
    <main>
      <Routes>
        <Route path="/" Component={LoginContainer} />
        <Route path="/forgotPassword" Component={ForgotPasswordContainer} />
        <Route path="/passwordReset" Component={PasswordTokenResetContainer} />
        <Route path="/login" Component={LoginContainer} />
        <Route path="/userArea/*" Component={UserContainer} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <MessagesContainer />
    </main>
  );
};

export default connect(
  (state) => ({
    maintenanceChecked: state.maintenance[MAINTENANCE_CHECKED],
    maintenanceEnabled: state.maintenance[MAINTENANCE_ENABLED],
    messageDe: state.maintenance[MAINTENANCE_MESSAGE_DE],
    messageEn: state.maintenance[MAINTENANCE_MESSAGE_EN]
  }),
  (dispatch) => bindActionCreators({ doLogin, loadMaintenanceStatus }, dispatch)
)(AppContent);
